import React, {useRef, useEffect, useState, useContext} from 'react';
import {Handle} from 'reactflow';
import {useSelector, shallowEqual} from 'react-redux';
import Select from 'react-select';

import {Chatbot} from '../../states/actions';
import {onEdit, onSetStart, onClose, onRemove, isLightColor} from '../../helpers/block-helper';
import {ColorPicker} from '../ColorPicker';
import {CKEditor} from '@ckeditor/ckeditor5-react';
import {User} from '../../states/actions';
import ClassicEditor from 'ckeditor5-custom-build';
import {InputComponent, SelectComp, TextareaComponent, PreviewComponent, NodeComponent, IntNodeComponent} from './Components'
import { GlobalStateContext } from '../GlobalState';
import {createSelectNodeData} from '../../states/selectors/chatbotSelectors';

const setNode = (node) => {
  window.el = node.id;
}

export const InvoiceBlock = React.memo((node) => {
  const {block, start, progress} = useSelector(createSelectNodeData(node.id), shallowEqual);
  const bot = { progress: progress || [] };

  if (!block) {
    return null;
  }

  const {data} = block;

  return (
    <>
      <IntNodeComponent bot={bot} name="Invoice" icon="payment" data={data} node={node} start={start}/>
    </>
  );
});


export const InvoiceEditor = ({nodeid, block, data, variableoptions}) => {

    const handleBlur = (e) => {   
      Chatbot.setBlockData(block.id, {[e.target.name]: e.target.value});
    };
 
    return (
      <>
         

            <div className='section'>INVOICE LOADER (System Block)</div>

            <div className="alert alert-warning mt-2" role="alert">
              <small>
                <strong>⚙️ System Block</strong> - Executes automatically, no user interaction
                <br/>
                Loads invoice data from database using invoice MongoDB _id
              </small>
            </div>

            <SelectComp 
              data={data} 
              name="Invoice ID Variable" 
              dataname="invoice_id_variable" 
              placeholder="Select variable containing invoice_id" 
              options={variableoptions} 
              block={block} 
              value="label"
            />

            <br/><br/>
            <>VARIABLES SAVED: </><br/>
            <i>
              <strong>Invoice:</strong> invoice_id, invoice_no, amount, amount_total, prepayment_applied, invoice_type, invoice_status, invoice_already_paid
              <br/>
              <strong>Client:</strong> client_id, client_name, firstname, lastname, client_email, client_type, client_pid, business_name, business_address, business_reg_code
              <br/>
              <strong>Lawyer:</strong> partner_crm_id, partner_name, partner_email, partner_company_name, partner_company_address, partner_company_reg_id, partner_vat, partner_hourlyprice
              <br/>
              <strong>Project:</strong> related_project_id, related_project_no
            </i>
            <br/><br/>
            <div className="alert alert-success mt-2" role="alert">
              <small>
                <strong>💰 Payment Amount Logic:</strong>
                <br/>
                • <strong>amount</strong>: Remaining balance to pay (after prepayments) - use this for payment block
                <br/>
                • <strong>amount_total</strong>: Full original invoice amount
                <br/>
                • <strong>prepayment_applied</strong>: Total prepayment already applied
                <br/>
                Formula: amount = amount_total - prepayment_applied
              </small>
            </div>
            <br/><br/>
            <div className="alert alert-success mt-2" role="alert">
              <small>
                <strong>💡 Name Splitting:</strong> client_name is automatically split into firstname and lastname for compatibility with payment block
              </small>
            </div>

            <div className="alert alert-info mt-2" role="alert">
              <small>
                <strong>Chat data and subscription flows:</strong>
                <br/>
                <strong>invoice_no</strong> and <strong>invoice_id</strong> are used for the <strong>Montonio / one-time payment</strong> block.
                Subscription (EveryPay) writes <strong>subscription_invoice_no</strong> and <strong>subscription_invoice_id</strong> instead, so a flow can have both without cross-contamination.
                <br/><br/>
                <strong>Requirements:</strong>
                <br/>
                • invoice_id must be imported from URL (use Data block first)
                <br/>
                • invoice_id format: MongoDB ObjectId (24-character hex)
                <br/><br/>
                <strong>On Success (OK) - Goes to success path when:</strong>
                <br/>
                • Invoice found (regardless of payment status)
                <br/>
                • All variables populated (34 variables)
                <br/>
                • If already paid: invoice_already_paid = true
                <br/><br/>
                <strong>On Fail - Goes to fail path when:</strong>
                <br/>
                • Invoice not found (invalid _id)
                <br/>
                • Invalid invoice_id format
                <br/>
                • Database error
              </small>
            </div>
            
            <div className="alert alert-warning mt-2" role="alert">
              <small>
                <strong>⚠️ Payment Status Checking:</strong>
                <br/>
                Use a Condition Block after Invoice Block to check "invoice_already_paid" variable.
                <br/>
                If TRUE: show "already paid" message
                <br/>
                If FALSE/undefined: continue to payment
              </small>
            </div>

            <InputComponent 
              data={data} 
              name="Wait Message (optional)" 
              dataname="waitmessage" 
              placeholder="Loading invoice data..." 
              onBlur={handleBlur}
            />

      </>
    )
}

